<template>
    <div class="jf_container">
        <div class="jf_conditionBox">
            <el-select
                class="assort"
                v-model="assort"
                placeholder="请选择分类"
                clearable
                @change="searchParam.typeid=assort;getRuleList()"
            >
                <el-option
                    v-for="item in addRuleOptions"
                    :key="item.id+100"
                    :label="item.typename"
                    :value="item.id"
                >
                    <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                </el-option>
            </el-select>
            <mySearch
                class="my-search"
                @searchData="searchData"
                :paramData="searchParam"
                v-model="searchContent"
                searchApi="point_rule/index"
            ></mySearch>
            <button class="jf_btn" @click="showAssortBox=true">分类管理</button>
            <button class="createBtn" @click="showRuleBox=addRule=true;resetSingleRule()">新增规则</button>
        </div>
        <!-- 数据表格 -->
        <el-table class="elTable" :data="tableData" v-if="tableData.length>0">
            <el-table-column
                prop="typename"
                label="积分分类"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="rule_name"
                label="规则名称"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="rule_des"
                label="积分细则"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="奖励类型" align="center">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.rule_type == 1 ? "奖分": "扣分"}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="标准分数" align="center">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.score_type == 1 ? scope.row.score: scope.row.score_min+' ~ '+scope.row.score_max}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="rule_notes"
                label="备注"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="gangwei"
                label="适用范围"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="操作" header-align="center">
                <template slot-scope="scope">
                    <el-button
                        @click="handleEditRule(scope.row)"
                        type="text"
                        size="small"
                        style="color:#8CBB77"
                        v-if="scope.row.centre_id"
                    >修改</el-button>
                    <el-button
                        @click="handleDelete(scope.row.id, 'rule')"
                        type="text"
                        size="small"
                        style="color:#ff5454"
                        v-if="scope.row.centre_id"
                    >删除</el-button>
                    <el-button
                        @click="lookRule=true;handleEditRule(scope.row)"
                        type="text"
                        size="small"
                        style="color:#8CBB77"
                    >查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 页码 -->
        <p
            class="pageTotal"
        >共有 {{pageData.count}} 条记录 当前 {{pageData.page}} 页/共 {{pageData.pagetotal}} 页</p>
        <el-pagination
            class="pageBody"
            @current-change="getRuleList(1)"
            :current-page.sync="pageData.page"
            background
            layout="prev, pager, next"
            :total="pageData.count*1"
        ></el-pagination>
        <div class="myDialog" v-if="showAssortBox">
            <!-- 分类管理 -->
            <div class="myDialog_content" v-if="!showAddAssort">
                <h4 class="myDialog_h">
                    分类管理
                    <i class="close el-icon-circle-close-outline el-icon-circle-close" @click="showAssortBox=false"></i>
                </h4>
                <button
                    class="createBtn"
                    @click="showAddAssort=true"
                    v-if="assortList&&assortList.length>0"
                >新增</button>
                <li
                    class="assortList clearfix"
                    v-for="(item, index) in assortList"
                    :key="index+200"
                    :class="{'first_item':index===0}"
                >
                    <span
                        class="assort_name"
                        :class="{'zhanwei':!item.child || item.child.length==0}"
                        @click="showDetail(item, index)"
                    >
                        <!-- 箭头 -->
                        <i
                            :class="{'activeI': activeLi===index}"
                            v-if="item.child && item.child.length>0"
                        ></i>
                        {{item.typename}}
                    </span>
                    <span @click="handleEditAssort(item)" v-if="item.centre_id !== 0">修改分类</span>
                    <span @click="handleDelete(item.id, 'assort')" v-if="item.centre_id !== 0">删除分类</span>
                    <div
                        class="assort_child"
                        v-if="item.child && item.child.length>0"
                        :style="{'height': activeLi===index?36*item.child.length+'px':0}"
                    >
                        <li v-for="child in item.child" :key="child.id+400">
                            {{child.typename}}
                            <span
                                @click="handleEditAssort(child)"
                                v-if="child.centre_id !== 0"
                            >修改</span>
                            <span
                                @click="handleDelete(child.id, 'assort')"
                                v-if="child.centre_id !== 0"
                            >删除</span>
                        </li>
                    </div>
                </li>
                <p
                    class="addAssortWord"
                    @click="showAddAssort=true"
                    v-if="!assortList || assortList.length==0"
                >
                    <i class="el-icon-circle-plus-outline"></i> 请点击这里进行添加分类
                </p>
                <button class="assort_confim-btn" @click="showAssortBox=false">返回</button>
            </div>
            <!-- 新增分类 -->
            <div class="myDialog_content assort_add" v-if="showAddAssort">
                <h4 class="myDialog_h">
                    {{isEditAssort?'修改':'新增'}}分类
                    <i
                        class="close el-icon-circle-close-outline el-icon-circle-close"
                        @click="showAddAssort=isEditAssort=false"
                    ></i>
                </h4>
                <div class="inp_wrap">
                    <label>父级分类:</label>
                    <el-select
                        v-model="pid"
                        placeholder="请选择父级分类"
                        :disabled="isEditAssort && pid===0?true:false"
                    >
                        <el-option
                            v-for="item in assortOptions"
                            :key="item.id+600"
                            :label="item.typename"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </div>
                <div class="inp_wrap">
                    <label>分类名称:</label>
                    <el-input placeholder="请输入分类名称" v-model="typename"></el-input>
                </div>
                <div class="btnWrap">
                    <button class="assort_confim-btn" @click="showAddAssort=isEditAssort=false">取消</button>
                    <button class="assort_confim-btn confim" @click="handleSubmitAssort">确定</button>
                </div>
            </div>
        </div>
        <!-- 新增 编辑 查看 规则-->
        <div class="myDialog" v-if="showRuleBox">
            <div class="myDialog_content rule_add">
                <h4 class="myDialog_h">
                    {{addRule?'新增':editRule&&!lookRule?'修改':'查看'}}规则
                    <i
                        class="close el-icon-circle-close-outline el-icon-circle-close"
                        @click="showRuleBox=addRule=editRule=lookRule=false"
                    ></i>
                </h4>
                <div class="inp_wrap">
                    <label>积分分类:</label>
                    <el-select
                        v-model="singleRule.type_id"
                        placeholder="请选择分类"
                        @change="getRulePid"
                    >
                        <el-option
                            v-for="item in addRuleOptions"
                            :key="item.id"
                            :label="item.typename"
                            :value="item.id"
                            :disabled="item.pid==0"
                        >
                            <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="inp_wrap">
                    <label>规则名称:</label>
                    <el-input
                        type="textarea"
                        :rows="1"
                        placeholder="请输入内容"
                        resize="none"
                        v-model="singleRule.rule_name"
                    ></el-input>
                </div>
                <div class="inp_wrap">
                    <label>奖励类型:</label>
                    <el-radio v-model="singleRule.rule_type" label="1">奖分</el-radio>
                    <el-radio v-model="singleRule.rule_type" label="2">扣分</el-radio>
                    <label style="margin-left:30px">积分类型:</label>
                    <el-radio v-model="singleRule.score_type" label="1">固定</el-radio>
                    <el-radio v-model="singleRule.score_type" label="2">范围</el-radio>
                    <div class="count" v-if="singleRule.score_type==2" style="height:42px">
                        <el-input-number
                            class="leftCount"
                            type="number"
                            v-model="singleRule.score_min"
                            controls-position="right"
                            :min="1"
                            :max="singleRule.score_max*1"
                        ></el-input-number>-
                        <el-input-number
                            type="number"
                            v-model="singleRule.score_max"
                            controls-position="right"
                            :min="singleRule.score_min*1"
                        ></el-input-number>
                    </div>
                    <el-input class="countInp" type="number" v-model="singleRule.score" v-else></el-input>
                </div>
                <div class="inp_wrap">
                    <label style="vertical-align: top">积分细则:</label>
                    <el-input
                        autosize
                        type="textarea"
                        placeholder="请输入内容"
                        resize="none"
                        v-model="singleRule.rule_des"
                    ></el-input>
                </div>
                <div class="inp_wrap">
                    <label style="vertical-align: top">备注:</label>
                    <el-input
                        autosize
                        type="textarea"
                        placeholder="请输入内容"
                        resize="none"
                        v-model="singleRule.rule_notes"
                    ></el-input>
                </div>
                <div class="inp_wrap">
                    <label>适用范围:</label>
                    <el-select
                        class="multiple_selection"
                        v-model="singleRule.gangwei"
                        multiple
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in gangweiList"
                            :key="item+800"
                            :label="item"
                            :value="item"
                        ></el-option>
                    </el-select>
                </div>
                <div class="btnWrap" v-if="!lookRule">
                    <button
                        class="assort_confim-btn"
                        @click="showRuleBox=addRule=editRule=lookRule=false"
                    >取消</button>
                    <button class="assort_confim-btn confim" @click="handleSubmitRule">确定</button>
                </div>
                <div class="mask" v-if="lookRule"></div>
            </div>
        </div>
    </div>
</template>

<script>
import mySearch from "../../components/mySearch.vue";
var baseUrl_type = process.env.apiUrl + "point/point_type/";
var baseUrl_rule = process.env.apiUrl + "point/point_rule/";

export default {
    name: "shezhi",
    data() {
        return {
            activeLi: -1,
            tabData: ["日常奖扣", "岗位工作"],
            tabIndex: 0,
            assortOptions: [], // 新增分类中的父级下拉框
            pid: "",
            typename: "",
            activeId: "", // 当前修改的id
            assort: "",
            search: "",
            tableData: [],
            pageData: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            }, // 页数
            assortList: [], //分类列表
            showAssortBox: false, // 分类管理弹窗
            showAddAssort: false, // 新增分类
            addRuleOptions: [],
            /**
             * type_id 二级分类ID  type_pid 一级分类ID rule_name 事件规则名称
             *  rule_type 奖励类型 1.奖分 2.扣分   score_type  积分类型 1.固定分值 2.范围分值
             *   score 固定分值数  score_min 范围分指数 最小值 score_max 范围分指数 最大值
             * rule_des积分细则  rule_notes 事件描述 备注
             * gangwei 适用岗位 数组 [全体员工,老师,市场,营销,前台,中心总监]
             */
            singleRule: {},
            gangweiList: [
                "全体员工",
                "老师",
                "市场",
                "营销",
                "前台",
                "中心总监"
            ],
            aaa: 1,
            options: [],
            showRuleBox: false,
            addRule: false, // 新增规则
            editRule: false, // 编辑规则
            lookRule: false, // 查看规则
            isEditAssort: false,
            token: "",
            searchContent: "",
            searchParam: {
                typeid: null
            }
        };
    },
    created() {
        this.token = this.$cookies.get("token");
        this.resetSingleRule();
        this.getAssortList();
        this.getRuleList()
    },
    methods: {
        // 获取规则列表
        getRuleList(type) {
            if (type !== 1) {
                this.pageData.page = 1
            }
            let loadingInstance = this.$loading()
            let that = this;
            let params = {
                token: this.token,
                page: this.pageData.page,
                search: this.searchContent,
                typeid: this.searchParam.typeid
            };
            $.ajax({
                url: baseUrl_rule + "index",
                type: "post",
                data: params,
                success: function(data, status) {
                    if (data.status === 1) {
                        that.tableData = data.data;
                        that.pageData.count = data.map.count;
                        that.pageData.page = data.map.page*1;
                        that.pageData.pagetotal = data.map.pagetotal;
                    } else {
                        that.$message.error(data.msg);
                    }
                },
                fail: function(err, status) {

                },
                complete: function() {
                    loadingInstance.close();
                }
            });
        },
        // 获取分类列表
        getAssortList() {
            let loadingInstance = this.$loading()
            let that = this;
            $.ajax({
                url: baseUrl_type + "index",
                type: "post",
                data: {
                    token: that.token
                },
                success: function(data, status) {
                    if (data.status === 1) {
                        if (data.data && data.data.length > 0) {
                            that.assortList = data.data;
                            that.assortOptions = [
                                {
                                    typename: "-----顶级分类-----",
                                    id: 0
                                }
                            ];
                            that.addRuleOptions = []
                            data.data.forEach((element, index) => {
                                that.assortOptions.push({
                                    typename: element.typename,
                                    pid: element.pid,
                                    id: element.id
                                });
                                that.addRuleOptions.push({
                                    typename: element.typename,
                                    pid: element.pid,
                                    id: element.id
                                });
                                if (element.child && element.child.length > 0) {
                                    element.child.forEach((ele, i) => {
                                        that.addRuleOptions.push({
                                            typename: ele.typename,
                                            pid: ele.pid,
                                            id: ele.id
                                        });
                                    });
                                }
                            });
                        } else {
                            that.$message.error(data.msg);
                        }
                    }
                },
                fail: function(err, status) {
                },
                complete: function() {
                    loadingInstance.close();
                }
            });
        },
        handleTabIndex(data) {
            this.tabIndex = data;
        },
        showDetail(item, i) {
            if (!item.child || item.child.length == 0) return;
            if (this.activeLi === i) {
                this.activeLi = -1;
            } else {
                this.activeLi = i;
            }
        },
        // 删除 分类 或者 规则
        handleDelete(id, type) {
            let tip = "",
                baseUrl = "",
                callback = "";
            if (type == "assort") {
                tip = "确定要删除此分类吗，删除后将无法恢复";
                baseUrl = baseUrl_type;
                callback = this.getAssortList;
            } else if (type == "rule") {
                tip = "确定要删除此积分项目吗，删除后将无法恢复";
                baseUrl = baseUrl_rule;
                callback = this.getRuleList;
            }
            this.$confirm(tip, "删除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                customClass: "myTip"
            })
                .then(() => {
                    let loadingInstance = this.$loading()
                    let that = this;
                    $.ajax({
                        url: baseUrl + "delete",
                        type: "post",
                        data: {
                            token: that.token,
                            id: id
                        },
                        success: function(data, status) {
                            if (data.status === 1) {
                                that.$message({
                                    type: "success",
                                    message: "删除成功!"
                                });
                                callback();
                            } else {
                                that.$message.error(data.msg);
                            }
                        },
                        fail: function(err, status) {
                        },
                        complete: function() {
                            loadingInstance.close();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        // 修改分类按钮 函数
        handleEditAssort(item) {
            this.isEditAssort = this.showAddAssort = true;
            this.pid = item.pid;
            this.typename = item.typename;
            this.activeId = item.id;
        },
        // 新增 或者 修改分类提交
        handleSubmitAssort() {
            if (this.pid === "") {
                this.$message.error("请选择父级分类");
                return;
            }
            if (this.typename.trim() == "") {
                this.$message.error("请输入分类名称");
                return;
            }
            let loadingInstance = this.$loading()
            let that = this;
            let url = this.isEditAssort ? "update" : "add";
            $.ajax({
                url: baseUrl_type + url,
                type: "post",
                data: {
                    token: that.token,
                    typename: that.typename.trim(),
                    pid: that.pid,
                    id: that.isEditAssort ? that.activeId : null
                },
                success: function(data, status) {
                    if (data.status === 1) {
                        that.pid = that.typename = "";
                        that.$message({
                            message: that.isEditAssort
                                ? "修改分类成功"
                                : "新增分类成功",
                            type: "success"
                        });
                        that.getAssortList();
                        that.showAddAssort = that.isEditAssort = false;
                    } else {
                        that.$message.error(data.msg);
                    }
                },
                fail: function(err, status) {
                },
                complete: function() {
                    loadingInstance.close();
                }
            });
        },
        // 新增 或者 修改规则提交
        handleSubmitRule() {
            if (this.singleRule.type_pid === "") {
                this.$message.error("请选择分类");
                return;
            }
            if (this.singleRule.rule_name.trim() == "") {
                this.$message.error("请输入事件名称");
                return;
            }
            if (this.singleRule.score_type == 1 && this.singleRule.score == 0) {
                this.$message.error("请输入固定分数");
                return;
            }
            if (
                this.singleRule.score_type == 2 &&
                this.singleRule.score_max == 0
            ) {
                this.$message.error("最大范围分数不能为0");
                return;
            }
            if (this.singleRule.rule_des.trim() == "") {
                this.$message.error("请输入积分细则");
                return;
            }
            if (this.singleRule.gangwei.length == 0) {
                this.$message.error("请选择适用范围");
                return;
            }
            let loadingInstance = this.$loading()
            let that = this;
            let url = this.addRule ? "add" : "update";
            that.singleRule.token = that.token
            $.ajax({
                url: baseUrl_rule + url,
                type: "post",
                data: that.singleRule,
                success: function(data, status) {
                    if (data.status === 1) {
                        that.pid = that.typename = "";
                        that.$message({
                            message: that.editRule
                                ? "修改规则成功"
                                : "新增规则成功",
                            type: "success"
                        });
                        that.getRuleList();
                        that.showRuleBox = that.addRule = that.editRule = false;
                    } else {
                        that.$message.error(data.msg);
                    }
                },
                fail: function(err, status) {
                },
                complete: function() {
                    loadingInstance.close();
                }
            });
        },
        // 新增或者修改 规则时  选择分类id后 获取pid
        getRulePid(id) {
            this.addRuleOptions.forEach(ele => {
                if (ele.id == id) {
                    this.singleRule.type_pid = ele.pid;
                    return false;
                }
            });
        },
        // 修改分类规则 函数
        handleEditRule(item) {
            this.showRuleBox = this.editRule = true;
            this.singleRule.type_pid = item.type_pid;
            this.singleRule.type_id = item.type_id;
            this.singleRule.rule_name = item.rule_name;
            this.singleRule.rule_type = item.rule_type.toString();
            this.singleRule.score_type = item.score_type.toString();
            this.singleRule.score = item.score;
            this.singleRule.score_min = item.score_min;
            this.singleRule.score_max = item.score_max;
            this.singleRule.rule_des = item.rule_des;
            this.singleRule.rule_notes = item.rule_notes;
            this.singleRule.gangwei = item.gangwei.split(",");
            this.singleRule.id = item.id;
        },
        resetSingleRule() {
            this.singleRule = {
                type_pid: "",
                type_id: "",
                rule_name: "",
                rule_type: "1",
                score_type: "1",
                score: 0,
                score_min: "1",
                score_max: "30",
                rule_des: "",
                rule_notes: "",
                gangwei: [],
                id: null
            };
        },
        searchData(data) {
            this.tableData = data.data;
            this.pageData.count = data.map.count;
            this.pageData.page = data.map.page*1;
            this.pageData.pagetotal = data.map.pagetotal;
        }
    },
    components: {
        mySearch
    }
};
</script>
<style lang="less">
    .jf_container {
        .el-radio {
            color: #606266;
            cursor: pointer;
            margin-right: unset!important;
        }
        .el-table td, .el-table th {
            text-align: center!important;
        }
    }
</style>
<style scoped>
.jf_container {
    min-width: 800px;
}
.jf_conditionBox {
    width: 100%;
    height: 60px;
    padding-top: 10px;
    padding-left: 30px;
    background: #f5f5f5;
}
.elTable {
    width: 96%;
    margin: 20px 0 0 30px;
    text-align: center;
}
.assort {
    float: left;
}
.my-search {
    float: left;
    margin-left: 20px;
}
.jf_btn,
.createBtn {
    float: left;
    margin-left: 20px;
    outline: none;
    border: none;
    border-radius: 4px;
    width: 114px;
    height: 40px;
    font-size: 16px;
    text-align: center;
    color: #666;
    background: #f1f1f1;
}
.createBtn {
    float: right;
    margin-right: 20px;
    color: #fff;
    background: #8CBB77;
}
.assort_add {
    width: 500px;
}

.assort_add .inp_wrap {
    text-align: center;
}
.inp_wrap label {
    font-size: 15px;
}
.btnWrap {
    text-align: center;
}
.btnWrap .assort_confim-btn {
    display: inline-block;
    margin: 30px 20px 0;
}
.confim {
    color: #fff;
    background: #8CBB77;
}
.close {
    float: right;
    margin: 8px 20px;
}
.mask {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 90%;
    z-index: 9999;
}
.addAssortWord {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 100px 0;
    width: 100%;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
}
.addAssortWord i {
    margin-right: 10px;
    font-size: 22px;
}
.assort_child li {
    height: 36px;
    padding: 0 36px 0 50px;
    font-size: 14px;
    line-height: 36px;
}
.assort_child li:hover {
    background: #f1f0f8;
}
.assort_child li span {
    margin-left: 66px;
    font-size: 14px;
}
.zhanwei::before {
    display: inline-block;
    content: "";
    width: 12px;
    height: 12px;
}
.secondary {
    margin-left: 30px;
}

input[type="number"] {
    -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/pages/jifen/shezhi.vue